import React from 'react'
import moment from 'moment'
import map from 'lodash/map'
import partition from 'lodash/partition'
import ProductContainerSlot from './ProductContainerSlot'
import { findReplenishmentSlotActiveOrder, findProductReplenishmentName } from './shared'
import { ProductContainer, ReplenishmentOrder } from './types'

const SOLID_CONTAINER_ROWS = 7
const SOLID_CONTAINER_COLS = 7
const SOLID_CONTAINER_FRIDGE_COLS = 5
const SOLID_CONTAINER_NONFRIDGE_COLS = SOLID_CONTAINER_COLS - SOLID_CONTAINER_FRIDGE_COLS

const SOLID_CONTAINER_SLOT_COUNT = SOLID_CONTAINER_ROWS * SOLID_CONTAINER_COLS

interface Props {
  searchQuery: string,
  currentProductCategoryId: number,
  containers: Record<number, ProductContainer>,
  currentDate: moment.Moment,
  expandContainer: Function,
  draftReplenishmentOrder: ReplenishmentOrder,
  activeReplenishmentOrders: ReplenishmentOrder[],
  replenishmentView?: boolean,
  disabledSlotNumbers: number[],
  faultySlotNumbers?: number[]
}

const SolidsView: React.FC<Props> = ({
  searchQuery, currentProductCategoryId, containers, currentDate, expandContainer,
  draftReplenishmentOrder, activeReplenishmentOrders, replenishmentView,
  disabledSlotNumbers, faultySlotNumbers
}) => {

  const slots = map(Array.from(Array(SOLID_CONTAINER_SLOT_COUNT).keys()), slotIndex => {
    const slotNumber = slotIndex + 1

    return { slotNumber, container: containers[slotNumber] }
  })

  const [fridgeSlots, nonFridgeSlots] = partition(slots, slot =>
    (slot.slotNumber - 1) % SOLID_CONTAINER_COLS < SOLID_CONTAINER_FRIDGE_COLS
  )

  const hasDraftReplenishment = (slotNumber) => {
    return !!findReplenishmentSlotActiveOrder([draftReplenishmentOrder], 'solid', slotNumber)
  }

  const hasSentReplenishment = (slotNumber) => {
    return !!findReplenishmentSlotActiveOrder(activeReplenishmentOrders, 'solid', slotNumber)
  }

  const productReplenishmentName = (slotNumber) => {
    if(hasDraftReplenishment(slotNumber)) {
      return findProductReplenishmentName([draftReplenishmentOrder], 'solid', slotNumber)
    } else if(hasSentReplenishment(slotNumber)) {
      return findProductReplenishmentName(activeReplenishmentOrders, 'solid', slotNumber)
    }
    return null
  }

  const renderProductContainerSlot = (slot) => {
    return (
      <ProductContainerSlot
        key={slot.slotNumber}
        slotNumber={slot.slotNumber}
        container={slot.container}
        currentDate={currentDate}
        expandContainer={expandContainer}
        searchQuery={searchQuery}
        currentProductCategoryId={currentProductCategoryId}
        isLiquid={false}
        isDisabled={disabledSlotNumbers?.includes(slot.slotNumber)}
        isFaulty={faultySlotNumbers?.includes(slot.slotNumber)}
        replenishmentView={replenishmentView}
        hasDraftReplenishment={hasDraftReplenishment(slot.slotNumber)}
        hasSentReplenishment={hasSentReplenishment(slot.slotNumber)}
        productReplenishmentName={productReplenishmentName(slot.slotNumber)}
      />
    )
  }

  return (
    <div className='tab-content solids'
      style={{ gridTemplateColumns: `${SOLID_CONTAINER_FRIDGE_COLS}fr 20px ${SOLID_CONTAINER_NONFRIDGE_COLS}fr` }}
    >
      <div className='fridge' style={{ gridTemplateColumns: `repeat(${SOLID_CONTAINER_FRIDGE_COLS}, 1fr)` }}>
        {map(fridgeSlots, slot => renderProductContainerSlot(slot))}
      </div>
      <div className='fridge-seperator'>
        <i className='fridge-icon fa fa-snowflake-o' />
      </div>
      <div className='non-fridge' style={{ gridTemplateColumns: `repeat(${SOLID_CONTAINER_NONFRIDGE_COLS}, 1fr)` }}>
        {map(nonFridgeSlots, slot => renderProductContainerSlot(slot))}
      </div>
    </div>
  )
}

export default SolidsView
